import * as utils from './utils';
import { Challenge } from './Challenge'
import { paymentType } from './Auction'
import { sortOrderTypes } from './MomentMPListing'

let challenges: Challenge[] = null
let expiredChallenges: Challenge[] = null

export function setChallenges(c: Challenge[]) { challenges = c }
export function getChallenges(): Challenge[] { return challenges }
export function setExpiredChallenges(c: Challenge[]) { expiredChallenges = c }
export function getExpiredChallenges(): Challenge[] { return expiredChallenges }

export function getChallengeByChallengeID(challenges: Challenge[], challengeID: string): Challenge {
  if (!challenges) return null
  for (const challenge of challenges) if (challenge.topShotGUID === challengeID) return challenge
}

let momentSelectorResponseData: any = null
export function getMomentSelectorResponseData() { return momentSelectorResponseData }
export function setMomentSelectorResponseData(msrd: any) { momentSelectorResponseData = msrd }

// dapper mode
export let dmTrigger: string = 'd'
dmTrigger += 'ap'
dmTrigger += 'pe'
dmTrigger += 'r'
export function getDapperMode(): boolean { 
  const dm: string = localStorage.getItem('dm')
  return dm === 'true'
}
export function setDapperMode(dm: boolean) { 
  localStorage.setItem('dm', dm.toString() )
}

// user prefs
export function setPreferredMPSort(sort: sortOrderTypes) {
  localStorage.setItem('preferredMPSort', sort)
}
export function getPreferredMPSort(): sortOrderTypes {
  return localStorage.getItem('preferredMPSort') as sortOrderTypes
}
export function setPreferredPaymentTypes(paymentTypes: paymentType[]) {
  localStorage.setItem('preferredPaymentTypes', JSON.stringify(paymentTypes))
}
export function getPreferredPaymentTypes(): paymentType[] {
  const raw: string = localStorage.getItem('preferredPaymentTypes')
  if (!raw) return null
  return JSON.parse(raw)
}

export function setPreferredDealLiquidity(raindrops: { label: string, minRating: number }) {
  localStorage.setItem('preferredDealLiquidity', JSON.stringify(raindrops))
}
export function getPreferredDealLiquidity(): { label: string, minRating: number } {
  const value: string = localStorage.getItem('preferredDealLiquidity') 
  if (value == null) return null
  return JSON.parse(value)
}
export function setPreferredDealRating(dealRating: { label: string, minRating: number }) {
  localStorage.setItem('preferredDealRating', JSON.stringify(dealRating))
}
export function getPreferredDealRating(): { label: string, minRating: number } {
  const value: string = localStorage.getItem('preferredDealRating') 
  if (value == null) return null
  return JSON.parse(value)
}
export function setPreferredDealAudio(dealAudio: { label: string, minRating: number }) {
  localStorage.setItem('preferredDealAudio', JSON.stringify(dealAudio))
}
export function getPreferredDealAudio(): { label: string, minRating: number } {
  const value: string = localStorage.getItem('preferredDealAudio') 
  if (value == null) return null
  return JSON.parse(value)
}

export function setPreferredDealOfferRating(dealRating: { label: string, minRating: number }) {
  localStorage.setItem('preferredDealOfferRating', JSON.stringify(dealRating))
}
export function getPreferredDealOfferRating(): { label: string, minRating: number } {
  const value: string = localStorage.getItem('preferredDealOfferRating') 
  if (value == null) return null
  return JSON.parse(value)
}
export function setPreferredDealOfferAudio(dealAudio: { label: string, minRating: number }) {
  localStorage.setItem('preferredDealOfferAudio', JSON.stringify(dealAudio))
}
export function getPreferredDealOfferAudio(): { label: string, minRating: number } {
  const value: string = localStorage.getItem('preferredDealOfferAudio') 
  if (value == null) return null
  return JSON.parse(value)
}

// export function setPreferredDealLeague(league: string) {
//   localStorage.setItem('preferredDealLeague', JSON.stringify(league))
// }
// export function getPreferredDealLeague(): string {
//   const value: string = localStorage.getItem('preferredDealLeague') 
//   if (value == null) return null
//   return JSON.parse(value)
// }


// auction faq
export function setHasReadAuctionFAQ(read: boolean) {
  localStorage.setItem('hasReadAuctionFAQ', read.toString())
}
export function getHasReadAuctionFAQ(): boolean {
  const read: string = localStorage.getItem('hasReadAuctionFAQ')
  return read === 'true'
}

export function getNicePriceString(price: number): string {
  if (!price) return '-'
  if (price < 100000) return `$${Math.round(price).toLocaleString()}`
  const thousands: number = Math.round(price / 1000)
  return `$${thousands.toLocaleString()}K`
}

export function getNicePossibleDecimalPriceString(price: number): string {
  if (price === null) return ''
  if (price < 100 && price !== Math.floor(price)) return `$${price.toFixed(2)}`      // e.g. 3.50
  if (price < 100000) return `$${Math.round(price).toLocaleString()}`
  if (price < 1000000) {
    const thousands: number = Math.round(price / 1000)
    return `$${thousands.toLocaleString()}K` 
  }
  const millions: string = (price / 1000000).toFixed(2)
  return `$${millions}M` 
}

export function getNicePossibleDecimalPriceStringForFMV(price: number): string {
  if (price === null) return ''
  if (price < 3 && price !== Math.floor(price)) return `$${price.toFixed(2)}`      // e.g. 3.50
  if (price < 100000) return `$${Math.round(price).toLocaleString()}`
  if (price < 1000000) {
    const thousands: number = Math.round(price / 1000)
    return `$${thousands.toLocaleString()}K` 
  }
  const millions: string = (price / 1000000).toFixed(2)
  return `$${millions}M` 
}

export function getNiceDecimalPriceString(price: number): string {
  if (price === null) return ''
  if (price < 100000) {
    if (price === Math.round(price)) return `$${price.toLocaleString()}`
    return `$${price.toFixed(2)}`
  }
  if (price < 1000000) {
    const thousands: number = Math.round(price / 1000)
    return `$${thousands.toLocaleString()}K` 
  }
  const millions: string = (price / 1000000).toFixed(2)
  return `$${millions}M` 
}

export function getNiceGainString(gain: number): string {
  const nice: string = `Unrealized ${ gain < 0 ? 'loss of ' : 'gain of '}$${Math.round(Math.abs(gain)).toLocaleString()}`
  return nice
}

export function getNiceRealizedGainString(gain: number): string {
  const nice: string = `Realized ${ gain < 0 ? 'loss of ' : 'gain of '}$${Math.round(Math.abs(gain)).toLocaleString()}`
  return nice
}

export function getGainClass(gain: number): string {
  if (gain > 0) return 'positive'
  return 'negative'
}

export function teamAbbreviation(team: string): string {
  if (!team) return null
  if (team.length === 3 || team.startsWith('W-')) return team      // so we can do it twice without a problem
  
  // First, RIB hacks (don't need these anymore i don't think, now that I use SearchTags on server side)
  if (team === 'Seattle SuperSonics') return 'OKC'
  if (team === 'New Orleans Hornets') return 'NOP'     // not used?
  if (team === 'Oklahoma City Hornets') return 'NOP'   // not used?
  if (team === 'New Orleans/Oklahoma City Hornets') return 'NOP'
  if (team === 'Charlotte Bobcats') return 'CHA'
  if (team === 'New Jersey Nets') return 'BKN'

  if (team === 'Eastern Conference All-Stars') return 'EAST'
  if (team === 'Western Conference All-Stars') return 'WEST'

  const mascot: string = utils.getLastWord(team).toLocaleLowerCase()
  switch (mascot) {
    // NBA
    case 'hawks': return 'ATL';
    case 'celtics': return 'BOS';
    case 'nets': return 'BKN';
    case 'hornets': return 'CHA';
    case 'bulls': return 'CHI';
    case 'cavaliers': return 'CLE';
    case 'mavericks': return 'DAL';
    case 'nuggets': return 'DEN';
    case 'pistons': return 'DET';
    case 'warriors': return 'GSW';
    case 'rockets': return 'HOU';
    case 'pacers': return 'IND';
    case 'clippers': return 'LAC';
    case 'lakers': return 'LAL';
    case 'grizzlies': return 'MEM';
    case 'heat': return 'MIA';
    case 'bucks': return 'MIL';
    case 'timberwolves': return 'MIN';
    case 'pelicans': return 'NOP';
    case 'knicks': return 'NYK';
    case 'thunder': return 'OKC';
    case 'magic': return 'ORL';
    case '76ers': return 'PHI';
    case 'suns': return 'PHX';
    case 'blazers': return 'POR';
    case 'kings': return 'SAC';
    case 'spurs': return 'SAS';
    case 'raptors': return 'TOR';
    case 'jazz': return 'UTA';
    case 'wizards': return 'WAS';

    // ALL-STAR GAMES
    case 'lebron': return 'LEB';
    case 'durant': return 'DUR';
    case 'giannis': return 'GIA';
    case 'east': return 'EAST';
    case 'west': return 'WEST';
    case 'stewart': return 'W-STW';
    case 'wilson': return 'W-WIL';

    // WNBA
    // WNBA
    case 'dream': return 'W-ATL';
    case 'sky': return 'W-CHI';
    case 'sun': return 'W-CON';
    case 'wings': return 'W-DAL';
    case 'comets': return 'W-HOU'
    case 'fever': return 'W-IND';
    case 'aces': return 'W-LVA';
    case 'sparks': return 'W-LAS';
    case 'lynx': return 'W-MIN';
    case 'liberty': return 'W-NYL';
    case 'mercury': return 'W-PHO';
    case 'monarchs': return 'W-SAC';
    case 'storm': return 'W-SEA';
    case 'shock': return 'W-TUL';
    case 'mystics': return 'W-WAS';

    // With searchTags implementation, these are defunct
    case 'shock': return 'W-DET'
    case 'stars': return 'W-SAS'


  }
  return '---'
}

export function longTeamName(teamAbbrev: string): string {
  if (!teamAbbrev) return null
  if (teamAbbrev.includes(' ')) return teamAbbrev
  switch (teamAbbrev) {
    // NBA
    case 'ATL': return 'Atlanta Hawks';
    case 'BOS': return 'Boston Celtics';
    case 'BKN': return 'Brooklyn Nets';
    case 'CHA': return 'Charlotte Hornets';
    case 'CHI': return 'Chicago Bulls';
    case 'CLE': return 'Cleveland Cavaliers';
    case 'DAL': return 'Dallas Mavericks';
    case 'DEN': return 'Denver Nuggets';
    case 'DET': return 'Detroit Pistons';
    case 'GSW': return 'Golden State Warriors';
    case 'HOU': return 'Houston Rockets';
    case 'IND': return 'Indiana Pacers';
    case 'LAC': return 'LA Clippers';
    case 'LAL': return 'Los Angeles Lakers';
    case 'MEM': return 'Memphis Grizzlies';
    case 'MIA': return 'Miami Heat';
    case 'MIL': return 'Milwaukee Bucks';
    case 'MIN': return 'Minnesota Timberwolves';
    case 'NOP': return 'New Orleans Pelicans';
    case 'NYK': return 'New York Knicks';
    case 'OKC': return 'Oklahoma City Thunder';
    case 'ORL': return 'Orlando Magic';
    case 'PHI': return 'Philadelphia 76ers';
    case 'PHX': return 'Phoenix Suns';
    case 'POR': return 'Portland Trail Blazers';
    case 'SAC': return 'Sacramento Kings';
    case 'SAS': return 'San Antonio Spurs';
    case 'TOR': return 'Toronto Raptors';
    case 'UTA': return 'Utah Jazz';
    case 'WAS': return 'Washington Wizards';

    // ALL-STAR GAMES
    case 'LEB': return 'Team Durant';
    case 'DUR': return 'Team LeBron';
    case 'GIA': return 'Team Giannis';
    case 'EAST': return 'Eastern Conference All-Stars';
    case 'WEST': return 'Western Conference All-Stars';
    case 'W-STW': return 'Team Stewart';
    case 'W-WIL': return 'Team Wilson';

    // WNBA
    case 'W-ATL': return 'Atlanta Dream';
    case 'W-CHI': return 'Chicago Sky';
    case 'W-CON': return 'Connecticut Sun';
    case 'W-DAL': return 'Dallas Wings';
    case 'W-HOU': return 'Houston Comets';
    case 'W-IND': return 'Indiana Fever';
    case 'W-LVA': return 'Las Vegas Aces';
    case 'W-LAS': return 'Los Angeles Sparks';
    case 'W-MIN': return 'Minnesota Lynx';
    case 'W-NYL': return 'New York Liberty';
    case 'W-PHO': return 'Phoenix Mercury';
    case 'W-SAC': return 'Sacramento Monarchs';
    case 'W-SEA': return 'Seattle Storm';
    case 'W-WAS': return 'Washington Mystics';

    // With searchTags implementation, these are defunct
    case 'W-DET': return 'Detroit Shock';
    case 'W-SAS': return 'San Antonio Silver Stars';

  }
  return 'All Teams'

}


export function getClassNameBasedOnScore(score: number) {
  if (score >= 125000) return 'ultimate'
  if (score >= 25000) return 'legendary'
  if (score >= 5000) return 'rare'
  if (score >= 1000) return 'limitedEdition'
  return 'common'
}

export function getClassNameBasedOnScore2(score: number) {
  if (score >= 5000000) return 'ultimate'
  if (score >= 1000000) return 'legendary'
  if (score >= 250000) return 'rare'
  if (score >= 50000) return 'limitedEdition'
  return 'common'
}

export function getClassNameBasedOnAuctionScore(score: number) {
  if (score >= 1000) return 'ultimate'
  if (score >= 100) return 'legendary'
  if (score >= 50) return 'rare'
  if (score >= 10) return 'limitedEdition'
  return 'common'
}

export function getNiceCollectorScore(score: number): string {
  score = Math.round(score)
  if (score < 10000) return score.toString()
  if (score < 100000) return (score / 1000).toFixed(1) + 'K'
  if (score < 1000000) return (score / 1000).toFixed(0) + 'K'
  return (score / 1000000).toFixed(1) + 'M'
}

export function getNiceAuctionScore(score: number): string {
  if (!score) return '0'
  return score.toLocaleString()
}

export function sansPrefix(address: string): string {
  if (address == null) return null
  return address.replace(/^0x/, "")
}

export function withPrefix(address: string): string {
  if (address == null) return null
  return "0x" + sansPrefix(address)
}

export function convertRarityToSetVisualId(rarity: string): string {
  if (!rarity) return null
  return `SET_VISUAL_${rarity.toLocaleUpperCase()}`
}

// need to keep updating this
export const MAX_SERIES__NUMBER = 6

export function getSeriesName(series: number): string {
  if (series < 0 || series > MAX_SERIES__NUMBER) {
    return 'Series ?'
  }
  switch (series) {
    case 0: return 'Series 1'
    case 1: return 'Series 1'
    case 2: return 'Series 2'
    case 3: return 'Summer 2021'
    case 4: return 'Series 3'
    case 5: return 'Series 4'
    case 6: return 'Series 2023-24'
    case 7: return 'Series 2024-25'
  }
}

export function getSeriesNumber(series: string): number {
  if (!series) return null
  switch (series) {
    case 'Series 1': return 0     // no SetMaps actually have series as 1 
    case 'Series 2': return 2
    case 'Summer 2021': return 3
    case 'Series 3': return 4
    case 'Series 4': return 5
    case 'Series 2023-24': return 6
    case 'Series 2024-25': return 7
  }
  return null
}

export function getSeriesArray(): string[] {
  const seriesArray: string[] = []
  for (let i = 1; i <= MAX_SERIES__NUMBER; i++) {
    seriesArray.push(getSeriesName(i))
  }
  return seriesArray
}

(async () => {
  // console.log(prettyTimeAgo(300000))
  // console.log(timeAgo.format(300000))
})()
